export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment.json";